import _ from 'lodash';

export const rts = {
  handle_triggerAction: 'handle_triggerAction',
  handleSet_currentMenuType: 'handleSet_currentMenuType',
}

export const rightMenuTypes = {
  dashboards: 'dashboards',
  directLinksOverride: 'directLinksOverride',
  propsOverride: 'propsOverride',
  showDataJson: 'showDataJson',
  showLog: 'showLog',
  subActions: 'subActions',
}

export const rightMenuTriggerTypes = {
  frameworkRight: 'frameworkRight',
  openDb: 'openDb',
  propsSave: 'propsSave',
  settings: 'settings',
  display: 'display',
  toggle: 'toggle',
  directLinksOverride: 'directLinksOverride',
  dashboard: 'dashboard',
}

export const rightMenuReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleSet_currentMenuType:
      return { ...state, currentMenuType: action.options && action.options.rmt ? action.options.rmt : null, triggerActionType: null }

    case rts.handle_triggerAction:
      const { options } = action
      const { rmt, frt, dmt, frv } = options ?? {}
      switch (rmt) {
        case rightMenuTriggerTypes.propsSave:
          return { ...state, currentMenuType: null, triggerActionType: rmt, frt, dmt }
        default:
          return { ...state, triggerActionType: rmt, frt, dmt, frv }
      }

    default:
      return { ...state }
  }
}

export const rightMenuHandlers = (dispatch) => {
  return {
    handle_triggerAction: (options) => { dispatch({ type: rts.handle_triggerAction, dispatch, options }) },
    handleSet_currentMenuType: (options) => { dispatch({ type: rts.handleSet_currentMenuType, dispatch, options }) },
  }
} 